<template>
	<div class="head">
		<img src="@/assets/header.png" alt="" />
	</div>

	<div class="main font_medium r-40 g-relative p-3">
		<div class="icon">
			<img src="@/assets/0903/car.svg" class="icon-car" alt="" />
			<div class="icon-safety">
				<img src="@/assets/0903/safety.svg" class="" alt="" />
			</div>
		</div>
		<div class="font_large_x text-center">提交成功</div>
		<div class="font_medium c9 text-center mt-2 mb-2" style="line-height: 2">
			您的车险投保申请资料已经提交成功，<br />
			您可以和您的业务服务人员具体咨询车险报价！
		</div>
		<flex-box align="center" justify="center" gap="0.2em" class="c-suc">
			<img src="@/assets/0903/safety.svg" class="ico" />个人信息已加密保护
		</flex-box>
	</div>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
	setup(props, { emit, slots, attrs }) {},
	data() {
		return {}
	},
	computed: {},
	mounted() {},
	methods: {},
	components: {}
})
</script>

<style lang="scss" scoped="scoped">
.head {
	overflow: hidden;
	margin-bottom: -50px;

	img {
		display: block;
		width: 100%;
		height: auto;
	}
}

.main {
	background: #fff;

	.icon {
		width: 162px;
		height: 162px;
		position: relative;
		margin: 0 auto $space_3;

		img.icon-car {
			width: 100%;
			height: 162px;
			display: block;
		}

		.icon-safety {
			position: absolute;
			bottom: -15px;
			right: -30px;
			padding: 12px;
			background: #fff;
			border-radius: 99px;
			img {
				display: block;
				height: 75px;
				width: 75px;
			}
		}
	}

	.ico {
		width: 32px;
		height: 32px;
	}
}
</style>
